// Espelha backend/app/core/dominio.py — mesmos códigos, rótulos em português aqui.
export const RELACOES_GV = [
  { value: 'colaborador', label: 'Colaborador' },
  { value: 'ex_colaborador', label: 'Ex-colaborador' },
  { value: 'cliente', label: 'Cliente' },
  { value: 'revendedor', label: 'Revendedor' },
  { value: 'fornecedor', label: 'Fornecedor' },
  { value: 'prestador', label: 'Prestador de serviço' },
  { value: 'parceiro', label: 'Parceiro' },
  { value: 'candidato', label: 'Candidato a vaga' },
  { value: 'outro', label: 'Outro' },
];

export const PAPEIS_ENVOLVIDO = [
  { value: 'envolvido', label: 'Envolvido' },
  { value: 'responsavel', label: 'Responsável pelo fato' },
  { value: 'testemunha_ocular', label: 'Testemunha ocular' },
  { value: 'outro', label: 'Outro' },
];

export const TIPO_LABEL = {
  denuncia: 'denúncia',
  reclamacao: 'reclamação',
  sugestao: 'sugestão',
  elogio: 'elogio',
};

export const TIPO_TITULO = {
  denuncia: 'Denúncia',
  reclamacao: 'Reclamação',
  sugestao: 'Sugestão',
  elogio: 'Elogio',
};
